import React, { ReactNode, useEffect, useState } from "react";
import Icon from "../Icon";
import DotsLoader from "../DotsLoader";

export type ButtonPurpose =
	| "primary"
	| "secondary"
	| "success"
	| "danger"
	| "warning"
	| "info"
	| "light"
	| "dark"
	| "link"
	| "plain";
export interface ButtonProps {
	active?: boolean;
	classes?: string;
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseEnter?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	onMouseLeave?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	purpose: ButtonPurpose;
	title?: string;
	type?: "button" | "submit" | "reset";
	busy?: boolean;
	href?: string;
	id?: string;
	onInteract?: (data: { id: string; focused: boolean; hovered: boolean }) => void;
	forwardRef?: React.Ref<HTMLButtonElement>;
	disabled?: boolean;
	customBusyIcon?: React.ReactNode;
	children?: ReactNode;
}

const Button: React.FC<ButtonProps> = ({
	classes,
	children,
	href,
	onClick,
	purpose,
	type,
	active,
	busy,
	id,
	onInteract,
	forwardRef,
	disabled,
	customBusyIcon,
	...props
}) => {
	const [focused, setFocused] = useState(false);
	const [hovered, setHovered] = useState(false);
	useEffect(() => {
		if (onInteract) {
			onInteract({ id: id ?? "", focused, hovered });
		}
	}, [focused, hovered]);
	const btn = (
		<button
			className={`btn btn-${purpose} ${classes} ${active ? "active" : ""} ${busy ? "busy" : ""}`}
			onClick={onClick}
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
			onFocus={() => setFocused(true)}
			onBlur={() => setFocused(false)}
			id={id}
			disabled={disabled ?? false}
			type={type}
			ref={forwardRef}
			{...props}
		>
			<span className="btn-children">{children}</span>
			{busy ? (
				customBusyIcon ? (
					customBusyIcon
				) : (
					<Icon icon="spinner-third" classes="fa-spin btn-spinner" />
				)
			) : null}
		</button>
	);
	return href ? (
		<a
			className="btn-link-wrapper"
			href={href}
			onClick={(evt) => {
				if (onClick) {
					evt.preventDefault();
					evt.stopPropagation();
				}
			}}
		>
			{btn}
		</a>
	) : (
		btn
	);
};

export default Button;
